'use client';

import { useRef } from 'react';
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';
import type { ImageProps } from 'next/image';
import { SmartImage } from '@/components/ui/Skeleton';

// Article media frame: the image sits slightly oversized (scale 1.12) inside a
// forest-card and drifts vertically as the frame crosses the viewport — a quiet
// editorial parallax. The 12% overscan exactly covers the ±6% drift, so edges
// never show. Reduced motion renders the image static.
export default function ParallaxImage({
  className = 'aspect-video',
  ...imageProps
}: ImageProps & { className?: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const reduceMotion = useReducedMotion();

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  });
  const y = useTransform(scrollYProgress, [0, 1], ['-6%', '6%']);

  return (
    <div ref={ref} className={`forest-card relative overflow-hidden ${className}`}>
      <motion.div
        className="absolute inset-0"
        style={reduceMotion ? undefined : { y, scale: 1.12 }}
      >
        <SmartImage {...imageProps} fill className="object-cover" />
      </motion.div>
    </div>
  );
}
